import React, { FC } from "react";
import image from "../../../assets/images/logo/logo-removebg.png";

import {
  StyledWrap,
  StyledImg,
  StyledTitle,
  StyledDesc,
  StyledResetForm,
} from "./style";
import { Input } from "../../UI/Forms/FormElements";
import { Button } from "../../UI/Button";
import { useTranslation } from "react-i18next";
import { UnpackNestedValue, useForm } from "react-hook-form";
import { observer } from "mobx-react";

type Props = {
  handleSubmitForm: (email: string) => void;
};

const ForgotPasswordForm: FC<Props> = observer(({ handleSubmitForm }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: UnpackNestedValue<any>) => {
    handleSubmitForm(data.email);
  };

  return (
    <StyledWrap>
      <StyledImg>
        <img src={image} alt="forgot password" />
      </StyledImg>
      <StyledTitle>{t("components.ForgotPasswordForm.title")}</StyledTitle>
      <StyledDesc>{t("components.ForgotPasswordForm.description")}</StyledDesc>
      <form action="#" noValidate onSubmit={handleSubmit(onSubmit)}>
        <StyledResetForm>
          <Input
            type="email"
            id="email"
            width={[null, "250px"]}
            placeholder={t("components.SigninForm.emailPlaceholder")}
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "invalid email address",
              },
            })}
          />
          <Button
            type="submit"
            color="brand2"
            mt={["10px", 0]}
            ml={[0, "10px"]}
          >
            {t("components.ForgotPasswordForm.password")}
          </Button>
        </StyledResetForm>
      </form>
    </StyledWrap>
  );
});

export default ForgotPasswordForm;
